import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';

import { Modal } from 'react-bootstrap'

import { GET, httpOk, POST } from 'helpers/api'
import CustomSelect from 'components/CustomSelect';

const initData = {
    box_id: '',
    box_quantity: '',
    max_box_quantity: '0',
    comment: '',
};

function ProduceOrder({ modal, setModal, item, getData }) {
    const { t } = useTranslation();

    const [sendData, setSendData] = useState({ ...initData })
    const [boxes, setBoxes] = useState({
        boxes: []
    })

    async function create() {
        var sendDataCopy = { ...sendData }
        delete sendDataCopy.unit_id;
        const response = await POST(`/production/orders/${item.id}/transfer-fg/`, sendDataCopy)
        if (httpOk(response)) {
            setModal(false);
            setSendData({ ...initData })
            getData();
        }
    }

    function handleChange(e) {
        var sendDataCopy = { ...sendData };
        sendDataCopy[e.target.name] = e.target.value;
        setSendData(sendDataCopy);
    }

    useEffect(() => {
        async function getBoxes() {
            const response = await GET(`/production/orders/${item.id}/transfer-fg/`, { size: 1000 })
            if (httpOk(response)) {
                setBoxes(response.data)
            }
        }

        if (modal) {
            getBoxes()
        }
    }, [modal, item?.id]);

    return (
        <>
            <Modal show={modal} centered onHide={() => setModal(false)}>
                <i className="uil-times" onClick={() => setModal(false)}></i>
                <div className="modal-title mb-12">
                    {t('production_output')}
                </div>
                <div className="modal-subtitle mb-32">
                    {t('add_output_info_desc')}
                </div>

                <div className="d-flex flex-column gap-16 mb-32">
                    <div className="form-group">
                        <label>{t('box')}</label>
                        <CustomSelect
                            options={boxes?.boxes}
                            value={boxes?.boxes?.find(option => option.id === sendData?.box_id) || ''}
                            getOptionValue={(option) => option.id}
                            getOptionLabel={(option) => option.name}
                            onChange={(option) => setSendData({ ...sendData, box_id: option.id, max_box_quantity: option.max_box_quantity })}
                            placeholder={t('select_box')}
                            isClearable={false}
                        />
                    </div>

                    <div className="form-group">
                        <label>{t('quantity')}</label>
                        <input type="text" placeholder={sendData.max_box_quantity ?? '0'} name="box_quantity"
                            value={sendData.box_quantity} onChange={(e) => handleChange(e)} />
                    </div>

                    <div className="form-group">
                        <label>{t('comment')}</label>
                        <input type="text" placeholder={t('comment')} name="comment"
                            value={sendData.comment} onChange={(e) => handleChange(e)} />
                    </div>

                </div>

                <div className="modal-footer">
                    <button className="white" onClick={() => setModal(false)}>
                        {t('cancel')}
                    </button>
                    <button className="dark" onClick={() => create()}>
                        {t('save')}
                    </button>
                </div>
            </Modal>
        </>
    )
}

export default ProduceOrder